import { render, staticRenderFns } from "./cities_form.vue?vue&type=template&id=3d974407&"
import script from "./cities_form.vue?vue&type=script&lang=js&"
export * from "./cities_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports